'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rocket = require('./assets/rocket.mp3');

var _rocket2 = _interopRequireDefault(_rocket);

var _rocket3 = require('../../stores/rocket.store');

var _rocket4 = _interopRequireDefault(_rocket3);

var _reactSnowstorm = require('react-snowstorm');

var _reactSnowstorm2 = _interopRequireDefault(_reactSnowstorm);

var _SoundPlayer = require('../SoundPlayer/SoundPlayer');

var _SoundPlayer2 = _interopRequireDefault(_SoundPlayer);

var _Rocket = require('../Rocket/Rocket');

var _Rocket2 = _interopRequireDefault(_Rocket);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _Space = require('./components/Space');

var _Space2 = _interopRequireDefault(_Space);

var _Ship = require('./components/Ship');

var _Ship2 = _interopRequireDefault(_Ship);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Assets
// Libs
// Components


var RocketLauncher = function (_Component) {
  _inherits(RocketLauncher, _Component);

  function RocketLauncher() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RocketLauncher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RocketLauncher.__proto__ || Object.getPrototypeOf(RocketLauncher)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      status: null
    }, _this.launch = function () {
      if (_this.state.visible) return;

      _this.setState({
        status: 'prepare'
      }, _this.actualLaunch);
    }, _this.actualLaunch = function () {
      _this.audio.play();

      setTimeout(function () {
        _this.setState({
          status: 'show'
        });
      }, 500);
      setTimeout(function () {
        return _this.setState({
          status: 'launch'
        });
      }, 1500);
      setTimeout(function () {
        _this.setState({
          status: null
        });
      }, 2500);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RocketLauncher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.unsub = _rocket4.default.sub(this.launch);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unsub();
    }
  }, {
    key: 'renderSoundPlayer',
    value: function renderSoundPlayer() {
      var _this2 = this;

      var status = this.state.status;
      return !!status && _react2.default.createElement(_SoundPlayer2.default, {
        key: 'rocketlaunchersoundplayer',
        src: _rocket2.default,
        fade: status === 'launch',
        fadeLength: 1000,
        reference: function reference(dom) {
          _this2.audio = dom;
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var status = this.state.status;
      return [_react2.default.createElement(_Container2.default, {
        visible: !!status,
        key: 'rocketlaunchercontainer'
      }, _react2.default.createElement(_Space2.default, {
        visible: !!status,
        id: 'RocketSpace'
      }, _react2.default.createElement(_reactSnowstorm2.default, {
        targetElement: 'RocketSpace',
        animationInterval: 40,
        followMouse: false,
        snowStick: false,
        flakesMax: 64,
        flakesMaxActive: 32,
        useMeltEffect: false
      }), _react2.default.createElement(_Ship2.default, {
        status: status
      }, _react2.default.createElement(_Rocket2.default, {
        flying: !!status
      })))), this.renderSoundPlayer()];
    }
  }]);

  return RocketLauncher;
}(_react.Component);

exports.default = RocketLauncher;